<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :hot-key-grid-tab-index="1"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Pricing" />
    </template>
    <div class="item-price-update css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <dx-data-grid
              :data-source="productListDataSourceConfig"
              :columns="columns"
              @selection-changed="onSelectionChanged"
              :height="gridHeight - 20"
              @content-ready="addGridNoResults($event)"
              :allow-column-reordering="false"
              :column-chooser="{ enabled: false }"
            >
              <template #primaryImageTemplate="{ data }">
                <div>
                  <GcGridProductImage
                    :ItemCode="data.data.Code"
                    :HasPrimaryImage="data.data.HasPrimaryImage"
                    :Description="data.data.Description1"
                  />
                </div>
              </template>
            </dx-data-grid>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <GcHeaderContentDynamic
                title="Sales Order"
                :baseView="baseView"
                :primaryLabel="model.Description"
                :secondaryLabel="model.Code"
              />
            </DxItem>

            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible="formsConfig.editableOption"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxDropDownButton"
              v-if="baseView.mode != 'review'"
            />
          </DxToolbar>
          <DxToolbar class="model-view-toolbar">
            <DxItem
              widget="dxForm"
              location="before"
              :options="{
                formData: model,
                items: toolbarBranchItems,
                validationGroup: 'toolbarBranchForm',
                labelLocation: 'left',
              }"
              locate-in-menu="auto"
              ref="so-toolbar-form"
            ></DxItem>
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: 'toolbarForm',
                labelLocation: 'left',
                disabled: baseView.mode == 'review' ? true : false,
              }"
              locate-in-menu="auto"
              :disabled="baseView.mode == 'review' ? true : false"
            ></DxItem>
            <template #branchTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
          </DxToolbar>

          <!-- <div class="view-card responsive-paddings"> -->
          <dx-data-grid
            :data-source="productReviewDataSourceConfig"
            :columns="productReviewColumns"
            :height="gridHeight - toolBarHeight - 20"
            @content-ready="onContentReady"
          >
            <DxSearchPanel :visible="false" />
            <template #price-group-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.Description"
                :code="data.data.PriceGroupCode"
              />
            </template>

            <template #value-cell-template="{ data }">
              <div class="gc-editor-cell">
                <DxNumberBox
                  :value="data.value"
                  :format="getDecimalFormatByCode(13).Format"
                  class="gc-border-bottom-dotted"
                  @value-changed="onGridValueChanged($event, data)"
                  :min="0.0"
                  :max="999999999.9999"
                  :disabled="baseView.mode == 'review' ? true : false"
                />
              </div>
            </template>
          </dx-data-grid>
          <!-- </div> -->
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { ItemPriceUpdateService } from "../../_services/api/sales/item-price-update.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { ProductService } from "../../_services/api/products/product.service";
import {
  PricingTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/pricing-tabs";

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      noDataMessage: {
        addNew: {
          class: "no-data",
          title: "No Products",
          message:
            "Products must be in the system for them to appear here. Head over to the Product screen to start adding them.",
        },
      },
      BranchVisible: false,
      CellValueChanged: false,
      toolBarHeight: 0,

      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            this.$router.push({
              path: `/item-price-update/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          items: [{ menuText: "Save" }, { menuText: "Save & Recalculate" }],
          keyExpr: "menuText",
          displayExpr: "menuText",
          showArrowIcon: false,
          dropDownOptions: {
            width: "200px",
          },
          stylingMode: "text",
          icon: "floppy",
          onItemClick: (e) => {
            if (e.itemData.menuText == "Save") {
              this.saveItemPriceUpdate("N");
            } else {
              this.saveItemPriceUpdate("Y");
            }
          },
        },
      },
      model: {
        Code: "",
        Description: "",
        UpdateAll: true,
        BranchCode: undefined,
        BranchName: "",
        UpdateItemDataSource: [],
        CurrencyCode: "",
      },
    };
  },
  components: {},
  async created() {
    this.getDefaults();
    await this.$store.dispatch("screenFactors/getFactors", [65]);
    this.selectedIndex = GetIndexByTabName("Item Price Update");
    this.model.BranchCode = this.getFactorByCode(65).Factorc;
    if (this.baseView.mode != "create" && this.baseView.id != "") {
      this.getProductData(this.baseView.id);
    }
  },
  computed: {
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Item",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          dataField: "Description1",
          allowEditing: false,
          cellTemplate: "primaryImageTemplate",
        },
        {
          gcLabel: "Code",
          dataField: "Code",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: "Description1",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
      ]);
    },
    productReviewColumns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Price Group",
          dataField: "PriceGroupCode",
          cellTemplate: "price-group-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          gcExport: ["PriceGroupCode", "Description"],
        },

        {
          gcLabel: "Price Group",
          dataField: "PriceGroupCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: "Description",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "UM",
          dataField: "SalesUM",
          gcType: "String",
          width: 100,
        },

        {
          gcDynamicLabel: this.valueCaption,
          dataField: "PricingMethodValue",
          cellTemplate: "value-cell-template",

          gcType: "Decimal-4-4C",
          cssClass: "gc-editor-cell",
        },
      ]);
    },
    valueCaption() {
      return `Price (${this.model.CurrencyCode})`;
    },
    toolbarBranchItems() {
      var that = this;
      return [
        {
          dataField: this.BranchVisible ? "BranchCode" : null,
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: BranchService.dataSourceConfig("api/Branch", {
              sort: [{ selector: "Description", asc: true }],
              select: ["Description", "Code"],
              filter: ["Inactive", "=", "N"],
            }),
            valueExpr: "Code",
            searchExpr: ["Code", "Description"],
            searchMode: "contains",
            showClearButton: false,
            itemTemplate: "branchTemplate",
            searchEnabled: true,
            displayExpr: "Description",
            acceptCustomValue: false,
            onSelectionChanged: (e) => {
              if (e.selectedItem)
                that.model.BranchName = e.selectedItem.Description;

              that.CellValueChanged = false;
            },
            onOpened: async (e) => {
              if (this.CellValueChanged) {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to change the branch?",
                  "Unsaved changes"
                );

                if (!confirmLeaving) {
                  e.component.close();
                }
              }
            },
            onValueChanged: (e) => {
              if (e.value == null)
                that.model.BranchCode = this.getFactorByCode(65).Factorc;
            },
            width: 200,
          },
          label: {
            text: "Branch",
            visible: false,
          },
        },
      ];
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "UpdateAll",
          gcType: "Boolean",
          gcLabel: "Update All Branches",
        },
      ]);
    },
    tabs() {
      return PricingTabs;
    },
    productListDataSourceConfig() {
      return ProductService.dataSourceConfig("api/Product", {
        select: ["Code", "Description1"],
        filter: ["Inactive", "=", "N"],
        // sort: [{ selector: "Code", asc: true }],
      });
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
    productReviewDataSourceConfig() {
      return this.model.UpdateItemDataSource.filter((item) => {
        return this.model.BranchCode
          ? item.BranchCode == this.model.BranchCode
          : item;
      });
    },
  },
  methods: {
    async saveItemPriceUpdate(Recalculate) {
      this.showLoading(true);
      var payload = {
        ProductCode: this.model.Code,
        BranchCode: this.model.BranchCode,
        AllBranches: this.model.UpdateAll ? "Y" : "N",
        Recalculate: Recalculate,
        ItemPriceDetails: this.model.UpdateItemDataSource.reduce(
          (filtered, item) => {
            if (item.BranchCode == this.model.BranchCode) {
              var someNewValue = {
                PriceGroupCode: item.PriceGroupCode,
                PricingMethodValue: item.PricingMethodValue,
                SalesUM: item.SalesUM,
              };
              filtered.push(someNewValue);
            }
            return filtered;
          },
          []
        ),
      };

      this.$logger.trackEventButtonClick(
        `Item Price Update Recalculate ${Recalculate}`,
        payload
      );

      await ItemPriceUpdateService.saveItemPrice(payload)
        .then((result) => {
          this.$logger.debug("saveItemPriceUpdate result ", result);

          this.CellValueChanged = false;

          this.showLoading(false);
          if (Recalculate == "Y") {
            this.$notify(
              `Prices for Item : ${this.model.Description} and Branch : ${this.model.BranchName} have been updated.  Any open sales orders for the branch(es) that have this item have been recalculated.`,
              "success"
            );
          } else {
            this.$notify(
              `Prices for Item : ${this.model.Description} and Branch : ${this.model.BranchName} have been updated.`,
              "success"
            );
          }

          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/item-price-update/review/${result.data.ProductCode}`,
          });
        })
        .catch((error) => {
          this.$logger.debug("saveItemPriceUpdate error ", error);
          this.showLoading(false);
        });
    },
    async onGridValueChanged(valueChangedEventArg, cellInfo) {
      cellInfo.value = valueChangedEventArg.value;
      cellInfo.data.PricingMethodValue = valueChangedEventArg.value;
      this.CellValueChanged = true;
    },
    async getUpdateItemsDataList(Code) {
      await ItemPriceUpdateService.getDataByCode({
        url: "api/ItemPrice",
        select: [
          "PriceGroupCode",
          "Description",
          "SalesUM",
          "BranchCode",
          "PricingMethodValue",
          "ProductCode",
        ],
        sort: [
          { selector: "PriceGroupCode", asc: true },
          { selector: "SalesUM", asc: true },
        ],
        filter: `ProductCode eq '${Code}'`,
      }).then((result) => {
        this.$logger.debug("getUpdateItemsDataList ", result);
        this.model.UpdateItemDataSource = result.data.value;
        this.$logger.debug(
          "getUpdateItemsDataList ",
          this.model.UpdateItemDataSource
        );
      });
      this.BranchVisible = true;
    },
    onSelectionChanged({ selectedRowsData }) {
      this.$router.push({
        path: `/item-price-update/review/${selectedRowsData[0].Code}`,
      });
    },
    getProductData(code) {
      ProductService.getByCode(code).then((result) => {
        this.$logger.debug("result ", result);
        this.model.Code = result.data.value[0].Code;
        this.model.Description = result.data.value[0].Description1;
        this.getUpdateItemsDataList(this.model.Code);
      });
    },
    onContentReady() {
      this.toolBarHeight =
        document.getElementsByClassName("split-view-toolbar")[0].clientHeight +
        document.getElementsByClassName("model-view-toolbar")[0].clientHeight;
    },
    async getDefaults() {
      await DefaultCompanyBranchDivisionService.getDefault().then(
        async (result) => {
          if (result.data.value.length > 0) {
            await CompanyService.getByCompanyCode(
              result.data.value[0].CompanyCode
            ).then((res) => {
              this.model.CurrencyCode = res.data.value[0].CurrencyCode;
            });
          }
        }
      );
    },
    handleLocalRouteChange() {
      this.BranchVisible = false;
      this.getProductData(this.baseView.id);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
};
</script>

<style lang="scss"></style>
